import { createApp } from 'vue'
import Circle from './Circle.vue'
import './assets/global.css'

createApp(Circle).mount('#circle')
